import * as THREE from "three";
import { useMemo } from "react";

const FRAME_W = 0.06;
const FRAME_D = 0.04;
const FRAME_COLOR = "#111111";

// Shared, module-level resources. Every GlassQuad looks identical, so there is no
// reason to build a separate material/geometry per instance (48 quads in the scene).
// meshStandardMaterial (vs the previous meshPhysicalMaterial) drops the clearcoat/
// transmission shader path — far cheaper while looking the same at opacity 0.1.
const GLASS_MATERIAL = new THREE.MeshStandardMaterial({
	color: "#88ccee",
	transparent: true,
	opacity: 0.1,
	roughness: 0.05,
	metalness: 0.05,
	depthWrite: false,
	side: THREE.DoubleSide,
});
const FRAME_MATERIAL = new THREE.MeshStandardMaterial({
	color: FRAME_COLOR,
	metalness: 0.3,
	roughness: 0.5,
});
const FRAME_GEO = new THREE.BoxGeometry(1, 1, 1);

export default function GlassQuad({ width, height, position, rotation, hide }: {
	width: number; height: number; position: [number, number, number]; rotation?: [number, number, number];
	hide?: { top?: boolean; bottom?: boolean; left?: boolean; right?: boolean };
}) {
	const geo = useMemo(() => new THREE.PlaneGeometry(width, height), [width, height]);
	const h = hide ?? {};

	const halfW = width / 2;
	const halfH = height / 2;

	return (
		<group position={position} rotation={rotation}>
			<mesh geometry={geo} material={GLASS_MATERIAL} receiveShadow />
			{!h.top && (
				<mesh geometry={FRAME_GEO} material={FRAME_MATERIAL} position={[0, halfH - FRAME_W / 2, 0]} scale={[width + FRAME_W * 2, FRAME_W, FRAME_D]} castShadow receiveShadow />
			)}
			{!h.bottom && (
				<mesh geometry={FRAME_GEO} material={FRAME_MATERIAL} position={[0, -halfH + FRAME_W / 2, 0]} scale={[width + FRAME_W * 2, FRAME_W, FRAME_D]} castShadow receiveShadow />
			)}
			{!h.left && (
				<mesh geometry={FRAME_GEO} material={FRAME_MATERIAL} position={[-halfW - FRAME_W / 2, 0, 0]} scale={[FRAME_W, height, FRAME_D]} castShadow receiveShadow />
			)}
			{!h.right && (
				<mesh geometry={FRAME_GEO} material={FRAME_MATERIAL} position={[halfW + FRAME_W / 2, 0, 0]} scale={[FRAME_W, height, FRAME_D]} castShadow receiveShadow />
			)}
		</group>
	);
}
